module.exports = __webpack_public_path__ + "media/auto-analy_pc.e569955f.mp4";